export default [
  {
    name: 'v4.supplier.dashboard',
    path: 'supplier/dashboard'
  }
];
